import actions from './actions'

export default {
  name: 'info',
  namespaced: true,
  actions
}